import React, { useEffect } from "react";
import { useDrag, useDragLayer } from "react-dnd";
import { BotoxJarType, DragableItemProps } from "../utils/types";
import { getEmptyImage } from "react-dnd-html5-backend";
import CustomDragLayer from "./DragLayer";
import { useScore } from "../utils/constants";

export default function DragableItem({
  hide,
  dragableItemValue,
  setBotoxCount,
  resetGame,
  dragableItemPosition,
  setHintVisability,
  hintVisbility,
  imgSrc
}: DragableItemProps) {
  const [{ isDragging }, drag, preview] = useDrag({
    type: BotoxJarType,
    item: { value: dragableItemValue },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  if (hide) return <></>
  return (
    <div className={`draggable-item `}>

      {/* <CustomDragLayer dragableItemPosition={dragableItemPosition} /> */}
      <article>
        <section className="bottles-count">
          <div>
            <img ref={drag} src={imgSrc} draggable="false" style={{}} />
          </div>
        </section>

      </article>
    </div>
  );
}
